
import { Button, Box, Collapse, FormControl, InputLabel, MenuItem, Stack, Select, TextField, FormHelperText, Typography } from "@mui/material"
import { useContext, useEffect, useRef, useState } from "react"
import SearchStock from "../SearchStock"
import { Link } from "react-router-dom"
import AuthContext from "../../context/AuthProvider"

const ForumPost = ({companyId, isOpen, setIsOpen, onPost, onDelete}) => {

	const postTitleRef						= useRef()
	const { auth }							= useContext(AuthContext)

	const [postTitle, setPostTitle] 		= useState('')
	const [postText, setPostText]			= useState('')
	const [postCategory, setPostCategory] 	= useState('')
	const [postCompany, setPostCompany]		= useState()
	const [isPosting, setIsPosting]			= useState(false)
	
	let formFields = {
		postTitle : {
			error : false,
			errorMessage : 'Você precisa preencher o título do tópico'
		},
		postText : {
			error : false,
			errorMessage : 'Você precisa preencher o conteúdo do tópico'
		},
		postCategory : {
			error : false,
			errorMessage : 'Você precisa escolher a categoria do tópico'
		},
		postCompany : {
			error : false,
			errorMessage : 'Você precisa escolher a empresa relacionada ao tópico'
		}	
	}

	const [formState, setFormState] 		= useState(formFields)

	useEffect(() => {
		if (auth?.userId) postTitleRef.current.focus()
	}, [isOpen])

	useEffect(() => {
		if (isOpen) {
			document.addEventListener('keydown', keydownHandler);
		}
		else {	
			document.removeEventListener('keydown', keydownHandler);
		}

		return () => {
			document.removeEventListener('keydown', keydownHandler);
		}
	}, [isOpen, postTitle, postText])

	const keydownHandler = (e) => {
		if (e.key === 'Enter' && e.ctrlKey) handlePostSave();
		//if (e.key == 'Escape') handlePostCancel();			
	}
 
	const handlePostCancel = () => {
		setIsOpen(false)
		setPostTitle('')
		setPostText('')		
	}

	const handlePostSave = () => {
		setIsPosting(true)

		if (handleValidation()) {
			onPost(
				null, 
				postTitle,
				companyId ? 'COMPANY' : postCategory, 						// Se veio um companyId, crava categoria como COMPANY
				postText, 
				postCategory === 'COMPANY' ? postCompany.id : companyId,		// Se foi selecionado manualmente categoria COMPANY, pega ID do componente de selecao, senao da pega da PROP
				null)
			.then(() => {
				handlePostCancel()
				setIsPosting(false)
			})
		}
		else {
			setIsPosting(false)
		}
	}

	const handleValidation = () => {
		let isValid = true

		if (postTitle.length < 1) {
			isValid = false
			formFields.postTitle.error = true
		}

		if (!companyId && postCategory === '') {
			isValid = false
			formFields.postCategory.error = true
		}

		if (!companyId && postCategory === 'COMPANY' && !postCompany) {
			isValid = false
			formFields.postCompany.error = true
		}

		if (postText.length < 1) {
			isValid = false
			formFields.postText.error = true
		}
				
		setFormState(formFields)
		return isValid
	}

	return (
		<Collapse in={isOpen}>
		{ auth?.userId ? (
			<Stack direction={'column'} spacing={1} sx={{marginTop: 1, alignItems: 'flex-end'}} width={'100%'}>
				<TextField 
					label="Título do Tópico" 
					fullWidth 
					value={postTitle || ''} 
					onChange={e => setPostTitle(e.target.value)} 
					inputRef={postTitleRef}
					error={formState.postTitle.error}
					helperText={formState.postTitle.error && formState.postTitle.errorMessage}
				/>

				{ !companyId ? (
					<Stack direction={'row'} spacing={1} width={'100%'}>
						<FormControl sx={{width: '100%'}} error={formState.postCategory.error}>
							<InputLabel>Área</InputLabel>
							<Select label="Área" value={postCategory} onChange={(e) => setPostCategory(e.target.value)}>
								<MenuItem value="GENERAL">Investimentos em Geral</MenuItem>
								<MenuItem value="ACOES">Investimentos em Ações no Brasil</MenuItem>
								<MenuItem value="STOCKS">Investimentos em Ações no Exterior</MenuItem>
								<MenuItem value="COMPANY">Empresa Específica</MenuItem>
								<MenuItem value="HELP">Ajuda / Suporte</MenuItem>
							</Select>
							{formState.postCategory.error ? <FormHelperText>{formState.postCategory.errorMessage}</FormHelperText> : null}
						</FormControl>
						{ postCategory === 'COMPANY' ? (
								<SearchStock 
									error={formState.postCompany.error}
									helperText={formState.postCompany.errorMessage}
									onClick={selectedCompany => setPostCompany(selectedCompany)}
								/>
						) : (
							null	
						)}
					</Stack>
				) : null }

				<TextField 
					label="Tópico"
					multiline 
					fullWidth 
					rows={4} 
					value={postText || ''}
					error={formState.postText.error}
					helperText={formState.postText.error && formState.postText.errorMessage} 
					onChange={e => setPostText(e.target.value)}/>

				<Stack direction={'row'}  spacing={1} width={'100%'} justifyContent={'right'}>
					<Button variant="contained" color="secondary" sx={{width: 100}} onClick={handlePostCancel}>Cancelar</Button>
					<Button variant="contained" sx={{width: 100}} onClick={handlePostSave} disabled={isPosting}>Postar</Button>
				</Stack>
			</Stack>
		) : (
			<Box sx={{height:100, marginTop: 1, display: 'flex', borderRadius: 1, boxShadow: 2, justifyContent: 'center', alignItems: 'center'}}>
				<Typography>Você precisa efetuar o login para postar! Clique <Link to={'/login'}>aqui</Link> para efetuar o login</Typography>
			</Box>
		)}
		</Collapse>

	)

}

export default ForumPost